import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetOcrTradesHistoryService } from "@/features/accounts/ocr/services/get-trades-history-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { GetOcrTradesHistoryResponseModel } from "@/features/accounts/ocr/services/get-trades-history-model";

export const useGetOcrTradesHistory = () => {
  const { setError } = useContext(ErrorDialogContext);

  const loadingCtx = useContext(LoadingModalContext);
  const getOcrTradesHistoryService = new GetOcrTradesHistoryService();

  // OCR取込履歴取得
  const getOcrTradesHistory = async (
    accountGroupId: string,
    ocrAccountId: string,
    offset?: string,
  ): Promise<GetOcrTradesHistoryResponseModel> => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await getOcrTradesHistoryService.getOcrTradesHistory({
        account_group_id: accountGroupId,
        ocr_account_id: ocrAccountId,
        offset,
      });
      return res;
    } catch (error) {
      // エラーハンドリング
      console.log("getOcrTradesHistory:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    getOcrTradesHistory: errorHandledAsync(getOcrTradesHistory, setError),
  };
};
